import * as React from "react";
import { BaseModal } from "../../../atoms/base-modal";
import { emptyFunction } from "../../../../utils/function-utils";

interface ModalWithInputProps {
  isActive: boolean;
  title: string;
  body: string;
  progress?: number;
}

export const LoadingModal: React.FunctionComponent<ModalWithInputProps> = ({
  isActive,
  title,
  body,
  progress,
}) => {
  return (
    <BaseModal isActive={isActive} title={title} onClose={emptyFunction}>
      <section className="modal-card-body">
        <h2>{body}</h2>
        <br />
        <progress
          className="progress is-small is-primary"
          value={progress}
          max="100"
        />
      </section>
    </BaseModal>
  );
};
